import { apolloClient } from '~/apollo-client';
import {
  Flex_UpdateConsolidatedUtilityAccountMutation,
  Flex_UpdateConsolidatedUtilityAccountMutationVariables,
  UpdateConsolidatedUtilityAccountInput,
} from '~/typings/graphql';
import { UPDATE_CONSOLIDATED_UTILITY_ACCOUNT } from './update-consolidated-utility-account.queries';

export const updateConsolidatedUtilityAccount = async (
  utilityAccountId: number,
  input: UpdateConsolidatedUtilityAccountInput,
) => {
  await apolloClient.mutate<
    Flex_UpdateConsolidatedUtilityAccountMutation,
    Flex_UpdateConsolidatedUtilityAccountMutationVariables
  >({
    mutation: UPDATE_CONSOLIDATED_UTILITY_ACCOUNT,
    variables: {
      utilityAccountId,
      input,
    },
  });
};
